const NAVIGATION_MATCH_BASE_URL = "https://navigation.local";

function normalizePathname(pathname = "/") {
  const decodedPath = decodeURIComponent(String(pathname || "/"));
  const trimmedPath = decodedPath.replace(/\/+$/, "");
  return trimmedPath || "/";
}

function parseNavigationUrl(link) {
  if (!link || typeof link !== "string") {
    return null;
  }

  const normalizedLink = link.trim();
  if (!normalizedLink || normalizedLink === "javascript:void(0)") {
    return null;
  }

  try {
    return new URL(normalizedLink, NAVIGATION_MATCH_BASE_URL);
  } catch (error) {
    return null;
  }
}

export function isNavigationLinkActive(currentUrl, targetUrl) {
  const current = parseNavigationUrl(currentUrl);
  const target = parseNavigationUrl(targetUrl);

  if (!current || !target) {
    return false;
  }

  if (normalizePathname(current.pathname) !== normalizePathname(target.pathname)) {
    return false;
  }

  for (const [key, value] of target.searchParams.entries()) {
    if (current.searchParams.get(key) !== value) {
      return false;
    }
  }

  return true;
}

export function getNavigationMatchScore(currentUrl, targetUrl) {
  if (!isNavigationLinkActive(currentUrl, targetUrl)) {
    return -1;
  }

  const target = parseNavigationUrl(targetUrl);
  if (!target) {
    return -1;
  }

  const pathnameScore = normalizePathname(target.pathname).length;
  const queryScore = Array.from(target.searchParams.keys()).length * 100;

  return pathnameScore + queryScore;
}

export function findBestNavigationPath(
  list,
  currentUrl,
  parentPath = [],
  resolveLink = (item) => item?.linkUrl || item?.link
) {
  if (!Array.isArray(list) || !currentUrl) {
    return null;
  }

  let bestMatch = null;

  list.forEach((item, index) => {
    const currentPath = [...parentPath, index];
    const link = resolveLink(item);
    const score = getNavigationMatchScore(currentUrl, link);

    if (score >= 0 && (!bestMatch || score > bestMatch.score)) {
      bestMatch = {
        path: currentPath,
        score,
      };
    }

    if (Array.isArray(item?.childrenList) && item.childrenList.length) {
      const childMatch = findBestNavigationPath(
        item.childrenList,
        currentUrl,
        currentPath,
        resolveLink
      );

      if (childMatch && (!bestMatch || childMatch.score > bestMatch.score)) {
        bestMatch = childMatch;
      }
    }
  });

  return bestMatch;
}
